module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3GoXz"))).then(() => parcelRequire('d0iPb'));